<!--Gentry & TBM-->
<template>
  <div style="width: 100%; height: 100%; position: absolute; color: white">
    <h1
      style="width: 100%; height: 70px; position: absolute; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      {{ title }}
    </h1>
    <div class="gentry1Div" v-if="showLoading" key="1"
         style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;"></div>
    </div>
    <div v-else-if="dataNotNull" key="2" style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div style="position: absolute; width:50%;height: 40%;font-size:120px;top: 20%; left: 0;">
        <div>{{ workers }}</div>
        <div @click="showDetail(0)" style="font-size: 85px;margin-top: 10px">Workers</div>
      </div>
      <div style="position: absolute; width:50%;height: 40%;font-size:120px;top: 20%; right: 0;">
        <div>{{ staff }}</div>
        <div @click="showDetail(1)" style="font-size: 85px;margin-top: 10px">Staff</div>
      </div>
      <div style="font-size: 80px; position:absolute; left: 0; bottom: 0; width: 100%; height: 25%">
        Inclusive Subcontractors
      </div>
    </div>
    <div v-else key="3"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      {{ no_data }}
    </div>
    <div class="daily_tbm_detail" v-show="showflag" id="daily_tbm_detail">
      <p style="margin-top: 20px; margin-left: 20px; text-align: left">{{ detailTitle }}</p>
      <div class="close_img_gentry" @click="detailClose"></div>
      <div class="gentryDiv" style="margin-top:40px; width: 100%; height: 540px">
        <div class="container1" style="height: 100%"></div>
      </div>
    </div>

    <div class="daily_tbm_detail1" v-show="showflag1" id="daily_tbm_detail1">
      <p style="margin-top: 20px; margin-left: 20px; text-align: left">{{ cur_com }}</p>
      <div class="close_img_gentry" @click="detail1Close"></div>
      <div class="gentryDiv1" style="margin-top:40px; width: 100%; height: 540px">
        <div class="container1" style="height: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import echarts from 'echarts'

export default {
  props: ['project_id'],
  name: "gentrys",

  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      name: "gentrys",
      workers: 0,
      staff: 0,
      dataNotNull: true,
      detailTitle: '',
      title_data: 'Daily Toolbox Meeting (TBM)',
      title_nodata: 'Daily Toolbox Meeting (TBM)',
      title: 'Daily Toolbox Meeting (TBM)',
      no_data: 'No Data !',
      cur_com: '',
      wo_con_tag: [],
      wo_con_list: [],
      wo_con_role: [],
      sta_con_tag: [],
      sta_con_list: [],
      sta_con_role: [],
      role_tag: [],
      role_list: [],
      myChart: null,
      myChart1: null,
      myChart2: null,
      showLoading: true,
      showflag: false,
      showflag1: false,
    }
  },
  methods: {
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    detailClose() {
      this.showflag1 = false
      this.showflag = false
    },
    detail1Close() {
      this.showflag1 = false
    },
    showDetail(type) {
      let that = this
      var tags = []
      var datas = []
      if (type === 0) {
        tags = that.wo_con_tag
        datas = that.wo_con_list
        that.detailTitle = that.workers
          + "  Workers"
      } else {
        tags = that.sta_con_tag
        datas = that.sta_con_list
        that.detailTitle = that.staff + "  Staff"
      }
      this.showflag = true
      this.$nextTick(() => {
        this.myChart = echarts.init(document.querySelector('.gentryDiv .container1'))
        // this.myChart.clear()
        this.myChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },
            formatter: function (params) {
              return params[0].value
            },
            textStyle: {
              fontSize: '40'
            }
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              yAxisIndex: [0],
              left: '95%',
              startValue: 0, // 从头开始。
              endValue: 5,  // 一次性展示5个。
              showDetail: false,
              zoomLock: true,
              width: '3%',
              orient: "vertical"
            }
          ],
          grid: {
            left: 220
          },
          xAxis: {
            type: 'value',
            show: false,
            axisLabel: {
              formatter: '{value}'
            }
          },
          yAxis: {
            type: 'category',
            inverse: true,
            data: tags,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#6CF'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 15,
              show: true,
              textStyle: {
                color: '#333',
                fontSize: 24
              },
            },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              name: '申请',
              type: 'bar',
              barWidth: '60%',
              data: datas,
              label: {
                normal: {
                  show: true,
                  color: '#6cf',
                  position: 'right',
                  fontSize: '25',
                  formatter: function (params) {
                    return params.value
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    return that.color[params.dataIndex]
                  },
                }
              },
            }
          ]
        })
        this.myChart.on('click', function (param) {
          that.showSecond(type, param.dataIndex)
        });
      })
    },
    showSecond(type, index) {
      let that = this
      that.showflag1 = true
      var legends = []
      var datas = []
      var results = []
      if (type == 0) {
        that.cur_com = that.wo_con_tag[index]
        let cindex = this.wo_con_tag.indexOf(that.cur_com)
        legends = that.wo_con_role[cindex].role_tag
        datas = that.wo_con_role[cindex].role_list
      } else {
        that.cur_com = that.sta_con_tag[index]
        let cindex = this.sta_con_tag.indexOf(that.cur_com)
        legends = that.sta_con_role[cindex].role_tag
        datas = that.sta_con_role[cindex].role_list
      }
      for (var i in legends) {
        results.push(
          {
            name: legends[i],
            value: datas[i]
          }
        )
      }
      that.$nextTick(() => {
        this.myChart1 = echarts.init(document.querySelector('.gentryDiv1 .container1'))
        this.myChart1.setOption({
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)",
            textStyle: {
              fontSize: 40
            }
          },
          legend: {
            type: 'scroll',
            width: 120,
            height: 250,
            orient: 'vertical',
            top: 'bottom',
            itemGap: 16,
            itemHeight: '18',
            itemWidth: 20,
            textStyle: {
              color: '#333',
              fontSize: '22'
            },
            data: legends
          },
          series: [{
            name: 'TBM',
            data: results,
            type: 'pie',
            hoverOffset: 5,
            radius: ['45%', '65%'],
            center: ['50%', '25%'],
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}',
                textStyle: {
                  fontSize: '36',
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '48',
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },

            itemStyle: {
              normal: {
                color: function (params) {
                  return that.color[params.dataIndex]
                }
              },
              //鼠标悬停时：
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
                borderWidth: 1
              }
            }
          }],
        })
      })
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.myChart2 = echarts.init(document.querySelector('.gentry1Div .container1'))
    this.myChart2.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });
    let postData = {
      project_id: this.my_project_id,
      start_date: this.getNowFormatDate(),
      end_date: this.getNowFormatDate(),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjTBMDetail", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr
      this.myChart2.hideLoading()
      this.showLoading = false
      let wo_role_tag = []
      let wo_role_list = []
      let sta_role_tag = []
      let sta_role_list = []
      if (errNo == "0") {
        this.dataNotNull = true
        this.title = this.title_data
        var result = resp.data.result;
        for (var i in result) {
          if (result[i].category === '0') {
            this.workers += 1
            let cindex = this.wo_con_tag.indexOf(result[i].short_name.substring(0, 13) + '\n' + result[i].short_name.substring(13, result[i].short_name.length))
            if (cindex < 0) {
              let last_index = this.wo_con_tag.length - 1
              if (last_index >= 0) {
                this.wo_con_role[last_index].role_tag = wo_role_tag
                this.wo_con_role[last_index].role_list = wo_role_list
              }
              this.wo_con_role.push({
                role_tag: [],
                role_list: []
              })
              this.wo_con_tag.push(result[i].short_name.substring(0, 13) + '\n' + result[i].short_name.substring(13, result[i].short_name.length))
              this.wo_con_list.push(1)
              wo_role_tag = []
              wo_role_list = []
            } else {
              this.wo_con_list[cindex] += 1
            }
            let rindex = wo_role_tag.indexOf(result[i].role_name_en)
            if (rindex < 0) {
              wo_role_tag.push(result[i].role_name_en)
              wo_role_list.push(1)
            } else {
              wo_role_list[rindex] += 1
            }
          } else {
            this.staff += 1
            let cindex = this.sta_con_tag.indexOf(result[i].short_name.substring(0, 13) + '\n' + result[i].short_name.substring(13, result[i].short_name.length))
            if (cindex < 0) {
              this.sta_con_role.push({
                role_tag: [],
                role_list: []
              })
              let last_index = this.sta_con_tag.length - 1
              if (last_index >= 0) {
                this.sta_con_role[last_index].role_tag = sta_role_tag
                this.sta_con_role[last_index].role_list = sta_role_list
              }
              this.sta_con_tag.push(result[i].short_name.substring(0, 13) + '\n' + result[i].short_name.substring(13, result[i].short_name.length))
              this.sta_con_list.push(1)
              sta_role_tag = []
              sta_role_list = []
            } else {
              this.sta_con_list[cindex] += 1
            }
            let rindex = sta_role_tag.indexOf(result[i].role_name_en)
            if (rindex < 0) {
              sta_role_tag.push(result[i].role_name_en)
              sta_role_list.push(1)
            } else {
              sta_role_list[rindex] += 1
            }
          }
        }
        //添加最后的workder
        let last_index = this.wo_con_tag.length - 1
        if (last_index >= 0) {
          this.wo_con_role[last_index].role_tag = wo_role_tag
          this.wo_con_role[last_index].role_list = wo_role_list
        }
        //添加最后的staff
        last_index = this.sta_con_tag.length - 1
        if (last_index >= 0) {
          this.sta_con_role[last_index].role_tag = sta_role_tag
          this.sta_con_role[last_index].role_list = sta_role_list
        }
      } else {
        this.dataNotNull = false
        this.title = this.title_nodata
        this.workers = '0'
        this.staff = '0'
        this.no_data = errStr
      }
    }).catch(error => {
      this.myChart2.hideLoading()
      this.showLoading = false
      this.dataNotNull = false
      this.title = this.title_nodata
      this.no_data = error
      alert(error)
    })
    // this.dragFunc("daily_tbm_detail")
    // this.dragFunc("daily_tbm_detail1")
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
    if (this.myChart1) {
      this.myChart1.clear()
    }
    if (this.myChart2) {
      this.myChart2.clear()
    }
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.daily_tbm_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 62%;
  height: 80%;
  left: 5%;
  top: 12%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.daily_tbm_detail1 {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 30%;
  height: 80%;
  right: 2%;
  top: 12%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.close_img_gentry {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 20px;
  top: 20px;
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/gentry.vue